module.exports = __webpack_public_path__ + "img/academy-badge-certified-fundamentals.b5ff924.svg";